/* ---------------------------------------------------------------
   JAC'D UP CUSTOM - scroll motion.

   Settled with Jac 2026-09-04: "Standard" intensity with fade-out.

   Scroll-LINKED, not fire-once. Craft's own animations.js triggers
   at a threshold and is done; this tracks the scroll continuously,
   which is what makes it read as expensive rather than jumpy. The
   two coexist: Craft drives .scroll-trigger on stock sections, this
   drives [data-jd-reveal] on hand-built ones.

   The exit fade is deliberately tight - it only bites in the last
   13% of the viewport before an element leaves the top. Widen that
   and content starts dimming while someone is still reading it,
   which is the failure mode that makes this effect feel cheap.

   data-jd-d="0|1|2..." staggers an element within its section.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  /* HEROES SIT STEADY. A hero is already on screen when the page
     loads, so animating it in makes the site look like it is
     assembling itself instead of simply being there, and fading it
     out on the first scroll is worse - the first thing someone reads
     dissolves while they are reading it. Nathan asked for this on the
     Engraved hero (2026-09-04) and again on the homepage hero
     (2026-09-05). Anything inside one of these is pinned visible once
     and never touched again.

     .jd-line   - the Engraved line announcement
     .jd-hero   - the homepage type-led hero
     [data-jd-static] - the escape hatch: put it on any wrapper that
                        should opt out, so the next hero does not need
                        this file edited at all.

     This has to pin opacity explicitly: jacdup-brand.css starts every
     [data-jd-reveal] at opacity 0 to stop a flash before this script
     runs, so an element that is merely SKIPPED would stay invisible
     forever. Skipping means "show it and forget it", not "ignore it". */
  var STATIC_WITHIN = '.jd-line, .jd-hero, [data-jd-static]';

  function pin(el) {
    el.style.opacity = '1';
    el.style.transform = 'none';
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-jd-reveal]').forEach(pin);
    return;
  }

  var DIST = 34;      // px of lift
  var ENTER = 0.26;   // fraction of viewport the entrance plays over
  var EXIT = 0.13;    // fraction of viewport the exit plays over
  var STAG = 75;      // px of trigger offset per stagger step

  var els = [];
  var queued = false;

  function collect() {
    els = [];
    [].slice.call(document.querySelectorAll('[data-jd-reveal]')).forEach(function (el) {
      if (el.closest(STATIC_WITHIN)) {
        pin(el);
      } else {
        els.push(el);
      }
    });
  }

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function paint() {
    queued = false;
    var vh = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      var d = (parseFloat(el.getAttribute('data-jd-d')) || 0) * STAG;
      var enter = ease(clamp((vh - r.top - d) / (vh * ENTER)));
      var exit = ease(clamp(r.bottom / (vh * EXIT)));
      el.style.opacity = (enter * exit).toFixed(3);
      el.style.transform = 'translateY(' + ((1 - enter) * DIST).toFixed(1) + 'px)';
    }
  }

  function request() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(paint);
  }

  function start() {
    collect();
    paint();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  /* The theme editor adds and removes sections without a reload. */
  document.addEventListener('shopify:section:load', function () { collect(); paint(); });
  document.addEventListener('shopify:section:unload', function () { collect(); });
})();
